/* eslint-disable import/prefer-default-export */

// 注销流程中对应的各个组件名
export const Target = {
    RevokeLoading: 0, // 过渡 loading
    RevokeCondition: 1, // 注销条件
    RevokeProtocol: 2, // 注销协议
    Reconfirm: 3, // 倒计时二次确认
    RevokeAccount: 4, // 账号验证
    IOSRevalidate: 5, // iOS 验证
    Hesitation: 6, // 接收犹豫期
    Success: 7, // 撤销成功
    SuccessWithHesitate: 8, // 撤销（附带犹豫期）成功
    0: 'RevokeLoading',
    1: 'RevokeCondition',
    2: 'RevokeProtocol',
    3: 'Reconfirm',
    4: 'RevokeAccount',
    5: 'IOSRevalidate',
    6: 'Hesitation',
    7: 'Success',
    8: 'SuccessWithHesitate',
};
